import React from "react";
//#region redux
//#endregion
//#region types
import { TextInputWithSuggestionsProps } from "models/propTypes/wintFormPropsTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import { Autocomplete } from "@mui/material";
import BaseInput from "./baseInput";
import useAutoCompleteCommonProps from "./useAutoCompleteCommonProps";
//#endregion

function TextInputWithSuggestions(props: TextInputWithSuggestionsProps) {
  const options = props.suggestions ?? [];

  const onChange = (event: any, newValue: AutocompleteListItem | string | null) => {
    if (typeof newValue === "string") {
      props.setValue(newValue);
    } else {
      props.setValue(newValue?.value);
    }
  };

  const onInputChange = (event: any, value: string, reason: string) => {
    props.setValue(value);
  };

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setTimeout(() => {
      props.onBlur(e);
    });
  };

  const commonProps = useAutoCompleteCommonProps(props.disabled, props.hasError);

  return (
    <Autocomplete
      {...commonProps}
      freeSolo
      options={options}
      loading={props.suggestions === undefined}
      value={props.value ?? null}
      onBlur={onBlur}
      onChange={onChange}
      onInputChange={onInputChange}
      renderInput={(params) => (
        <BaseInput
          type="text"
          name={props.name}
          value={props.value}
          label={props.label}
          setValue={() => {}}
          touched={props.touched}
          setTouched={props.setTouched}
          hasError={props.hasError}
          onChange={params.inputProps.onChange ?? (() => {})}
          onBlur={onBlur}
          inputProps={params.inputProps}
          InputProps={params.InputProps}
          optional={props.optional}
        />
      )}
      data-testid={`${props.name}TextInputWithSuggestions`}
    />
  );
}

export default TextInputWithSuggestions;
